import { create } from 'zustand';
import {AuthStore, ICurrentUser} from "../types/user";
import {IUserProfile} from "../types/api";

const useAuthStore = create<AuthStore>((set, get) => ({
  user: {} as ICurrentUser,
  setUser: (user: ICurrentUser) => set({ user }),

  userProfile: null,
  setUserProfile: (user: IUserProfile | null) => set({ userProfile: user }),

  userGroupPermissions: {},
  setUserGroupPermissions: (permissionsOrUpdater) => {
    if (typeof permissionsOrUpdater === 'function') {
      set(state => ({
        userGroupPermissions: permissionsOrUpdater(state.userGroupPermissions)
      }));
    } else {
      set({ userGroupPermissions: permissionsOrUpdater });
    }
  },
  isAuthenticated: () => {
    const { user } = get();
    return user?.authenticated ?? false;
  },

  shouldShowCompanyWarning: () => {
    const { user, isAuthenticated } = get();
    return isAuthenticated() && !user?.hasAssociatedCompany;
  },

  clearAuth: () => set({
    user: {} as ICurrentUser,
    userGroupPermissions: {}
  }),
}));

export default useAuthStore;
